<div class="search" [class.active]="isOpen">
	<ng2-completer 
		#autocompleteSearch 
		inputId="autocompleteSearch"
		[(ngModel)]="searchQuery"
		[datasource]="data"
		[minSearchLength]="3"
		[autoHighlight]="true"
		[clearUnselected]="false"
		[fillHighlighted]="false"
		[autoMatch]="true"
		[openOnFocus]="false"
		placeholder="{{ 'MENU.SEARCH' | translate }}"
		pause="750" 
		textNoResults="{{ 'SEARCH.NO_RESULTS_AUTOCOMPLETE' | translate }}"
		textSearching="{{ 'LOADING' | translate }}" 
		(keydown)="onKeydown($event)"
		(keyup)="onKeyup()"
		(selected)="onSelected($event)">
	</ng2-completer>

	<div class="search__btn" (click)="toggleSearch()"></div>
</div>
